/**
 * 查词页区块与 Tab 文案（查词页 / 设置页共用，勿在此处以外另起中文名）
 */

export const SECTION_META = {
  extended: {
    title: '拓展释义',
    desc: '语境用法、专业领域与英文释义'
  },
  practice: {
    title: '例句',
    desc: '双语对照、原声语料与权威出处'
  },
  network: {
    title: '词汇拓展',
    desc: '词组搭配、关联词汇、词根词缀、同义词辨析与词源'
  }
}

export const TAB_LABELS = {
  web: '语境释义',
  pro: '专业释义',
  ee: '英文释义',
  bilingual: '双语例句',
  native: '原声例句',
  authority: '权威例句',
  phrase: '词组搭配',
  syn: '同近义词',
  antonym: '反义词',
  root: '词根词缀',
  same: '同义词辨析',
  ety: '词源',
  basic: '基本释义',
  cn_dict: '汉语词典',
  inflections: '词形变化',
}
